import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'pr-parchment-marketing-tooltip',
  imports: [CommonModule, MatButtonModule, MatIcon],
  templateUrl: './parchment-marketing-tooltip.component.html',
  styleUrl: './parchment-marketing-tooltip.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ParchmentMarketingTooltipComponent {
  parchmentLandingPageUrl = 'https://principle.dental/integrations/parchment';
}
